import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../axiosInstance.js';
import { SideBar } from "../SideBar/SideBar.js";
import { Link } from "react-router-dom";
import { FaArrowRight } from "react-icons/fa";

const AboutPagePanel = () => {
  const [aboutBg, setAboutBg] = useState([]);
  const [aboutPageContent, setAboutPageContent] = useState([]);
  const [aboutUsContent, setAboutUsContent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [bgResponse, pageContentResponse, usContentResponse] = await Promise.all([
          axiosInstance.get('/aboutpage/bg'),
          axiosInstance.get('/aboutpage/content'),
          axiosInstance.get('/aboutpage/aboutus')
        ]);

        setAboutBg(bgResponse.data);
        setAboutPageContent(pageContentResponse.data);
        setAboutUsContent(usContentResponse.data);
        setLoading(false);

      } catch (error) {
        setError(error.message);
        setLoading(false);
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);

  const updateAboutBg = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('BackgroundImage', e.target.files[0]);

    try {
      const response = await axiosInstance.put(`/aboutpage/bg/${aboutBg[0]._id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      setAboutBg([response.data]);
      console.log('Updated aboutBg:', response.data);
    } catch (error) {
      console.error('Failed to update About Background:', error);
    }
  };

  const updateAboutPageContent = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const updatedContent = {
      title1: formData.get('title1'),
      description1: formData.get('description1'),
      title2: formData.get('title2'),
      description2: formData.get('description2'),
    };

    try {
      const response = await axiosInstance.put(`/aboutpage/content/${aboutPageContent[0]._id}`, updatedContent);
      setAboutPageContent([response.data]);
      console.log('Updated aboutPageContent:', response.data);
    } catch (error) {
      console.error('Failed to update About Page Content:', error);
    }
  };

  const updateAboutUsContent = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const updatedContent = {
      title: formData.get('title'),
      heading: formData.get('heading'),
      description: formData.get('description'),
    };

    try {
      const response = await axiosInstance.put(`/aboutpage/aboutus/${aboutUsContent[0]._id}`, updatedContent);
      setAboutUsContent([response.data]);
      console.log('Updated aboutUsContent:', response.data);
    } catch (error) {
      console.error('Failed to update About Us Content:', error);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    
    <><div className="flex">
      <SideBar />
      <div className="flex-1 h-screen p-6 overflow-auto bg-gray-100">
      <div className='max-w-3xl mx-auto panel-container'>
        <div className="panel-form bg-white p-8 rounded-lg shadow-xl">
          {/* About Background Section */}
          <section>
            <h2 className="admin-nav-heading text-2xl font-semibold mb-6 text-gray-800">About Background</h2>
            {aboutBg.length > 0 && aboutBg[0].BackgroundImage && (
              <img src={aboutBg[0].BackgroundImage} alt="Background" style={{ maxWidth: '100%' }} />
            )}
            <input               className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="file" onChange={updateAboutBg} />
          </section>

          {/* About Page Content Section */}
          <section>
            <h2>About Page Content</h2>
            {aboutPageContent.length > 0 && (
              <form  className="space-y-6"onSubmit={updateAboutPageContent}>
                <div>
                  <label>Title 1:</label>
                  <input                className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="text" name="title1" defaultValue={aboutPageContent[0].title1} />
                </div>
                <div>
                  <label>Description 1:</label>
                  <textarea               className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 name="description1" defaultValue={aboutPageContent[0].description1}></textarea>
                </div>
                <div>
                  <label>Title 2:</label>
                  <input               className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 type="text" name="title2" defaultValue={aboutPageContent[0].title2} />
                </div>
                <div>
                  <label>Description 2:</label>
                  <textarea               className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
 name="description2" defaultValue={aboutPageContent[0].description2}></textarea>
                </div>
                <button                 className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
 type="submit">Update About Page Content</button>
              </form>
            )}
          </section>

          {/* About Us Content Section */}
          <section>
            <h2>About Us Content</h2>
            {aboutUsContent.length > 0 && (
              <form onSubmit={updateAboutUsContent}>
                <div>
                  <label>Title:</label>
                  <input className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500" type="text" name="title" defaultValue={aboutUsContent[0].title} />
                </div>
                <div>
                  <label>Heading:</label>
                  <input   className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
type="text" name="heading" defaultValue={aboutUsContent[0].heading} />
                </div>
                <div>
                  <label>Description:</label>
                  <textarea className="w-full p-4  border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"  name="description" defaultValue={aboutUsContent[0].description}></textarea>
                </div>
                <button className="px-6 py-3 bg-blue-500 text-white font-semibold rounded-lg hover:bg-blue-600 transition-colors duration-300"  
type="submit">Update About Us Content</button>
              </form>
            )}
          </section>
        </div>
      </div>
    </div></div></>
  );
};

export default AboutPagePanel;
